export default [
    {
        path: "/xhs/operation/dashboard/view",
        name: "xhs-operation-dashboard",
        component: () => import("@/views/operation/dashboard/view.vue"),
    },
    {
        path: "/xhs/operation/account/list",
        name: "xhs-operation-account-list",
        component: () => import("@/views/operation/account/list.vue"),
    },
    {
        path: "/xhs/operation/account/brand",
        name: "xhs-operation-account-brand",
        component: () => import("@/views/operation/account/brand.vue"),
    },
    {
        path: "/xhs/operation/account/matrix",
        name: "xhs-operation-account-matrix",
        component: () => import("@/views/operation/account/matrix.vue"),
    },
    {
        path: "/xhs/operation/account/product",
        name: "xhs-operation-account-product",
        component: () => import("@/views/operation/account/product.vue"),
    },
    {
        path: "/xhs/operation/account/competitor",
        name: "xhs-operation-account-competitor",
        component: () => import("@/views/operation/account/competitor.vue"),
    },
    {
        path: "/xhs/operation/account/privilege",
        name: "xhs-operation-account-privilege",
        component: () => import("@/views/operation/account/privilege.vue"),
    },
    {
        path: "/xhs/operation/account/risk",
        name: "xhs-operation-account-risk",
        component: () => import("@/views/operation/account/risk.vue"),
    },

    {
        path: "/xhs/operation/strategy/lib",
        name: "xhs-operation-strategy-lib",
        component: () => import("@/views/operation/strategy/lib.vue"),
    },
    {
        path: "/xhs/operation/strategy/canvas",
        name: "xhs-operation-strategy-canvas",
        component: () => import("@/views/operation/strategy/canvas.vue"),
    },
    {
        path: "/xhs/operation/strategy/algorithm",
        name: "xhs-operation-strategy-algorithm",
        component: () => import("@/views/operation/strategy/algorithm.vue"),
    },
    {
        path: "/xhs/operation/strategy/plan",
        name: "xhs-operation-strategy-plan",
        component: () => import("@/views/operation/strategy/plan.vue"),
    },

    {
        path: "/xhs/operation/content/topic",
        name: "xhs-operation-content-topic",
        component: () => import("@/views/operation/content/topic.vue"),
    },
    {
        path: "/xhs/operation/content/generate",
        name: "xhs-operation-content-generate",
        component: () => import("@/views/operation/content/generate.vue"),
    },
    {
        path: "/xhs/operation/content/script",
        name: "xhs-operation-content-script",
        component: () => import("@/views/operation/content/script.vue"),
    },
    {
        path: "/xhs/operation/content/material",
        name: "xhs-operation-content-material",
        component: () => import("@/views/operation/content/material.vue"),
    },
    {
        path: "/xhs/operation/content/publish",
        name: "xhs-operation-content-publish",
        component: () => import("@/views/operation/content/publish.vue"),
    },

    {
        path: "/xhs/operation/placement/plan",
        name: "xhs-operation-placement-plan",
        component: () => import("@/views/operation/placement/plan.vue"),
    },
    {
        path: "/xhs/operation/placement/overview",
        name: "xhs-operation-placement-overview",
        component: () => import("@/views/operation/placement/overview.vue"),
    },
    {
        path: "/xhs/operation/placement/suggest",
        name: "xhs-operation-placement-suggest",
        component: () => import("@/views/operation/placement/suggest.vue"),
    },
    {
        path: "/xhs/operation/placement/attribution",
        name: "xhs-operation-placement-attribution",
        component: () => import("@/views/operation/placement/attribution.vue"),
    },

    {
        path: "/xhs/operation/kol/lib",
        name: "xhs-operation-kol-lib",
        component: () => import("@/views/operation/kol/lib.vue"),
    },
    {
        path: "/xhs/operation/kol/recruitment",
        name: "xhs-operation-kol-recruitment",
        component: () => import("@/views/operation/kol/recruitment.vue"),
    },
    {
        path: "/xhs/operation/kol/board",
        name: "xhs-operation-kol-board",
        component: () => import("@/views/operation/kol/board.vue"),
    },
    {
        path: "/xhs/operation/kol/effective",
        name: "xhs-operation-kol-effective",
        component: () => import("@/views/operation/kol/effective.vue"),
    },

    {
        path: "/xhs/operation/topic/keyword",
        name: "xhs-operation-topic-keyword",
        component: () => import("@/views/operation/topic/keyword.vue"),
    },
    {
        path: "/xhs/operation/topic/rank",
        name: "xhs-operation-topic-rank",
        component: () => import("@/views/operation/topic/rank.vue"),
    },
    {
        path: "/xhs/operation/topic/map",
        name: "xhs-operation-topic-map",
        component: () => import("@/views/operation/topic/map.vue"),
    },

    {
        path: "/xhs/operation/orchestration/rule",
        name: "xhs-operation-orchestration-rule",
        component: () => import("@/views/operation/orchestration/rule.vue"),
    },
    {
        path: "/xhs/operation/orchestration/flow",
        name: "xhs-operation-orchestration-flow",
        component: () => import("@/views/operation/orchestration/flow.vue"),
    },
    {
        path: "/xhs/operation/orchestration/template",
        name: "xhs-operation-orchestration-template",
        component: () => import("@/views/operation/orchestration/template.vue"),
    },
    {
        path: "/xhs/operation/orchestration/execution",
        name: "xhs-operation-orchestration-execution",
        component: () => import("@/views/operation/orchestration/execution.vue"),
    },

    {
        path: "/xhs/operation/engagement/message",
        name: "xhs-operation-engagement-message",
        component: () => import("@/views/operation/engagement/message.vue"),
    },
    {
        path: "/xhs/operation/engagement/profile",
        name: "xhs-operation-engagement-profile",
        component: () => import("@/views/operation/engagement/profile.vue"),
    },
    {
        path: "/xhs/operation/engagement/sop",
        name: "xhs-operation-engagement-sop",
        component: () => import("@/views/operation/engagement/sop.vue"),
    },

    {
        path: "/xhs/operation/report/dashboard",
        name: "xhs-operation-report-dashboard",
        component: () => import("@/views/operation/report/dashboard.vue"),
    },
    {
        path: "/xhs/operation/report/grow",
        name: "xhs-operation-report-grow",
        component: () => import("@/views/operation/report/grow.vue"),
    },
    {
        path: "/xhs/operation/report/option",
        name: "xhs-operation-report-option",
        component: () => import("@/views/operation/report/option.vue"),
    },
    {
        path: "/xhs/operation/report/review",
        name: "xhs-operation-report-review",
        component: () => import("@/views/operation/report/review.vue"),
    },

    {
        path: "/xhs/operation/compliance/brand",
        name: "xhs-operation-compliance-brand",
        component: () => import("@/views/operation/compliance/brand.vue"),
    },
    {
        path: "/xhs/operation/compliance/review",
        name: "xhs-operation-compliance-review",
        component: () => import("@/views/operation/compliance/review.vue"),
    },
    {
        path: "/xhs/operation/compliance/copyright",
        name: "xhs-operation-compliance-copyright",
        component: () => import("@/views/operation/compliance/copyright.vue"),
    },
    {
        path: "/xhs/operation/compliance/audit",
        name: "xhs-operation-compliance-audit",
        component: () => import("@/views/operation/compliance/audit.vue"),
    },

    {
        path: "/xhs/operation/setting/tenancy",
        name: "xhs-operation-setting-tenancy",
        component: () => import("@/views/operation/setting/tenancy.vue"),
    },
    {
        path: "/xhs/operation/setting/role",
        name: "xhs-operation-setting-role",
        component: () => import("@/views/operation/setting/role.vue"),
    },
    {
        path: "/xhs/operation/setting/approval",
        name: "xhs-operation-setting-approval",
        component: () => import("@/views/operation/setting/approval.vue"),
    },
    {
        path: "/xhs/operation/setting/integration",
        name: "xhs-operation-setting-integration",
        component: () => import("@/views/operation/setting/integration.vue"),
    },
    {
        path: "/xhs/operation/setting/fee",
        name: "xhs-operation-setting-fee",
        component: () => import("@/views/operation/setting/fee.vue"),
    },
]